import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '@/assets/app/css/sources.module.css';
import sourceImg from '@/assets/app/images/mypage/source.png';
import TitleHeader from '../common/TitleHeader';

const Sources: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <TitleHeader title="자료출처" onBack={() => navigate(-1)} />

      <main className="px-6 py-2 flex flex-col items-center">
        <div className="w-48 mb-8">
          <img src={sourceImg} alt="Book Cover" className="w-full rounded-[15px]" />
        </div>

        <div className="w-full space-y-6">
          <section>
            <h3 className="font-bold text-gray-800 mb-2 text-[16px]">책소개</h3>
            <p
              className="text-[#7F7F7F]"
              style={{ fontSize: 15, fontWeight: 800, lineHeight: 'normal' }}
            >
              "우리 아이 한국사를 놀이로 쉽게 접할 수 있을까요?"
              <br />
              『톰토미 100명의 위인 사운드북』은 대한민국 대표 역사
              <br />
              커뮤니케이션 기업 ㈜톰토미와, 배우 없는 정통 한국사
              <br /> 어린이 콘텐츠에서 풀어낸 프리미엄 사운드북입니다.
              <br />
              <br />
              조선의 왕들을 물론, 테크토승·대한민국을 둘러싼까지 함께
              <br /> 수록되어 미디어 노출 없이도 아이가 스스로 역사와 문화,
              <br /> 예절을 자연스럽게 익힐 수 있도록 설계했습니다.
              <br />
              <br />
              책의 모든 모서리는 라운딩 처리되어 있고 고급 종이코팅으로
              <br /> 마감되어, 어린아이가 손에 쥐고 넘겨도 다칠 염려가 없도록
              <br /> 안전성을 최우선으로 설계했습니다.
              <br />
              <br />
              '위인카드'는 세이펜과 연동되어 리스트를 누르면 위인의
              <br /> 일대기를 음악과 들려줍니다. 부모가 옆에서 읽어주지 않아도
              <br /> 아이 스스로 학습이 가능한 자기주도형 구성입니다.
              <br />
              <br />
              또한 세이펜이 없어도 온 가족이 함께 카드를 보며 즐길 수<br /> 있는 놀이형 학습
              콘텐츠로, 한 권으로 다양한 학습 경험을
              <br /> 제공합니다.
            </p>
          </section>

          <section>
            <h3 className="font-bold text-gray-800 mb-1 mt-4 text-[16px]">판매처 링크</h3>
            <a
              href="https://smartstore.naver.com/tomtomistore/products/12600176225"
              target="_blank"
              className="text-[#14A1C8] text-sm font-medium underline font-bold break-all"
            >
              https://smartstore.naver.com/tomtomistore/products/12600176225
            </a>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Sources;
